module.exports = __webpack_public_path__ + "static/assets/4d09ee02e4ae56cf656f9462de3282ab.png";